// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"103":"donations","443":"about","535":"login"}[chunkId] || chunkId) + "-legacy." + {"103":"c95388c8","443":"2a1b3847","448":"50c7e438","535":"c5b489b5"}[chunkId] + ".js";
};